var map = {
	"./bitski.svg": "8756",
	"./brave.svg": "9745",
	"./chrome.svg": "0747",
	"./coinbase_wallet.svg": "eb18",
	"./edge.svg": "0a9d",
	"./firefox.svg": "75d0",
	"./ledger.svg": "d87a",
	"./metamask.svg": "52c7",
	"./opera.svg": "3093",
	"./safari.svg": "c5a9",
	"./wallet_connect.svg": "ac73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";